import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import settings from '../settings'
import { formMetaData } from '../index'

const { isRTL, BUILD_DOMAIN } = settings

const HelmetConfig = ({ form = {}, children }) => {
  const formalooTitle = isRTL()
    ? 'فرمالو فرم‌ساز حرفه ای آنلاین'
    : 'Formaloo Fastest and Easiest way to create forms'
  const isFormLoaded = (key) => Boolean(form && form[key])

  const tagContent = {
    title: isFormLoaded('title')
      ? form.title
      : process.env.REACT_APP_TITLE_TAG || formalooTitle,
    image:
      isFormLoaded('logo') || isFormLoaded('logo_url')
        ? form.logo ?? form.logo_url
        : `${process.env.REACT_APP_FAVICONS_ROOT}/android-chrome-256x256.png`,
    favicon:
      isFormLoaded('logo') || isFormLoaded('logo_url')
        ? form.logo ?? form.logo_url
        : `${process.env.REACT_APP_FAVICONS_ROOT}/favicon.ico`,
    customDomain: isFormLoaded('custom_domain') ? form.custom_domain : null,
  }
  const isFormNps = Boolean(form.form_type === 'nps')

  const isFormOnMainDomain = Boolean(window.location.host === BUILD_DOMAIN)
  const isFormOnCustomDomain = Boolean(
    window.location.host === tagContent.customDomain
  )
  const isFormFoundByAddress = Boolean(formMetaData.formAddress)

  const shouldAddHelmet = () => {
    if (isFormNps) return false
    if (isFormOnMainDomain || isFormFoundByAddress || isFormOnCustomDomain)
      return true
    return false
  }

  /**
   * for this to work and replace existing elements
   * add `data-react-helmet="true"` to elements in index.html
   *
   * reference:
   * - https://github.com/nfl/react-helmet/issues/430#issuecomment-520364492
   *
   **/
  const HelmetTags = shouldAddHelmet() ? (
    <Helmet>
      <link rel="icon" href={tagContent.favicon} id="favicon" />
      <title>{tagContent.title}</title>
      <meta property="og:title" content={tagContent.title} />
      <meta property="og:image" content={tagContent.image} />
      <meta property="twitter:image" content={tagContent.image} />
    </Helmet>
  ) : null

  return (
    <React.Fragment>
      {HelmetTags}
      <React.Fragment>{children}</React.Fragment>
    </React.Fragment>
  )
}
const mapStateToProps = (state) => ({
  form: state.mainForm,
})
export default connect(mapStateToProps)(HelmetConfig)
